export default __webpack_public_path__ + "static/media/icon_hallinto_lukittu.7f71ee6a.svg";